import React from 'react';
import { Link, withRouter } from 'react-router-dom';

import {
  getHourAndMinute,
  getEstimatedDuration,
  getMaintenanceStatus,
  getTimeAgo,
  formatText,
  getDateRange,
  isWithin24Hours,
  isUpcoming } from '../utils/index.js';

import './styles.scss';
import outageImg from './assets/red-check.svg';
import incidentImg from './assets/incident.svg';
import maintenanceImg from './assets/maintenance.svg';

const GetSpan = ({ children }) => {
  return (
    <span>{children}</span>
  )
};

const capitalize = (s) => {
  if (typeof s !== 'string') return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
}

class Incidents extends React.Component {
  constructor(props) {
    super(props);

    const { pathname } = window.location;
    this.state = {
      isPreview: pathname.includes('/public/')
    }
  }

  getBackLink = () => {
    const { isPreview } = this.state;
    const { isIncidentPage, statusPageId } = this.props;

    let backlink = '/';

    if (isPreview) {
      backlink = isIncidentPage ? `/public/${statusPageId}/history` : `/public/${statusPageId}`;
    } else {
      backlink = isIncidentPage ? `/history` : '/';
    }

    return backlink;
  }

  goToIncidentPage(incidentId) {
    if (this.props.isIncidentPage) {
      return;
    }

    const { pathname } = this.props.location;

    if (pathname.includes('/history')) {
      this.props.history.push(`${pathname}/${incidentId}`)
    }
  }

  capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  getIcon(type) {
    if (type === 'maintenance') {
      return maintenanceImg;
    } else if (type === 'incident') {
      return incidentImg;
    } else if (type === 'outage') {
      return outageImg;
    }
  }

  render() {
    let { incidents } = this.props;
    const { isHomePage, isIncidentPage, statusPageId, statuspage } = this.props;
    const { isPreview } = this.state;
    if (isHomePage) {
      incidents = incidents.filter((incident) => {
        if (incident.type !== 'maintenance') {
          return isWithin24Hours(new Date(incident.date));
        } else {
          const endDate = new Date(incident.endDate);
          return isWithin24Hours(endDate) || isUpcoming(endDate);
        }
      });
    }

    const Tag = isIncidentPage ? GetSpan : Link;

    return(
      <div className="incidents-container">
        {isHomePage === false && !isIncidentPage && <span className="incidents-title">History</span>}
        {isHomePage === false && isIncidentPage === true && <span className="incidents-title">Updates</span>}
        {isHomePage === true && (incidents.length > 0) && <span className="incidents-title">Recent updates</span>}
        {incidents.length <= 0 && isHomePage && <span className="incidents-title">No update reported today.</span>}
        {!isHomePage &&
          <Link
            className="text-cta nav-link-black float-right"
            to={{
              pathname: this.getBackLink(),
              statuspage
            }}>
            <span className="arrow">←</span> Back
          </Link>
        }
        <div className="mb-1" />

        

        {incidents.length <= 0 && !isHomePage && <div className="whitebox full-width">No incidents reported.</div>}
        {incidents.map((incident, index) => (
          <Tag to={{
            pathname: `/history/${incident.uuid}`,
            statuspage,
            incident
          }}
          className={`no-pointer-cursor incident-link ${!isIncidentPage ? 'history-page' : ''}`}
          key={incident.id}
          >
            <div className={`${!isHomePage ? 'whitebox whitebox-incident' : 'whiteless-box'}`}>
              <div className="date">{getDateRange(incident)}</div>
              <div className="incident">
                {!!incident.type && <img className="incident-type-img" src={this.getIcon(incident.type)} />}
                {!!incident.type &&<span className="incident-type">{this.capitalize(incident.type)}</span>}
                <div className="title">{incident.title}
                {(incident.type === 'maintenance') && <div className="estimated-duration">{getEstimatedDuration(incident)}</div>}
                </div>
                {incident.updates.map((update, index) => (
                  <div className="update" key={update.id || index}>
                    <div className="time">{getHourAndMinute(update.UTCTime)} <div className="update-status">{incident.type === 'maintenance' ? getMaintenanceStatus(incident.date, incident.endDate, index) : capitalize(update.type)}</div> <span className="ago">Posted {getTimeAgo(update.UTCTime)}</span></div>
                    {!!update.text && <div className="text" dangerouslySetInnerHTML={{ __html: formatText(update.text) }} />}
                  </div>
                ))}
              </div>
            </div>
          </Tag>
        ))}

        {isHomePage && <div className="mb-2" />}
        {isHomePage &&
          <Link
            className="text-cta nav-link-black mb-1"
            to={{
              pathname: isPreview ? `/public/${statusPageId}/history` : '/history',
              statuspage
            }}>
            <span className="arrow">←</span> See history
          </Link>
        }
      </div>
    );
  }
}

export default withRouter(Incidents);
